module.exports = __webpack_public_path__ + "img/pending-credit-line.d4141046.jpg";